import React, { PureComponent, Fragment } from 'react';

import Button from 'shared/components/presentational/Button';
import MapInfoWindow from 'shared/components/presentational/Map/MapInfoWindow';

const {
  Header,
  Name,
  Type,
  ContentSection,
  CTASection
} = MapInfoWindow.children;

export default class MapShopDetails extends PureComponent {
  handleActionClick = () => {
    const { shop, onActionClick } = this.props;
    onActionClick(shop);
  };

  render() {
    const { shop, actionPending, t } = this.props;
    const { handleActionClick } = this;
    const { name, type, address1, zipcode, city, tel, fax } = shop;

    return (
      <Fragment>
        <Header>
          <Name itemProp="name">{name}</Name>
          <Type itemProp="description">{type}</Type>
        </Header>
        <ContentSection
          itemProp="address"
          itemScope
          itemType="http://schema.org/PostalAddress"
        >
          <span itemProp="streetAddress">{address1}</span>
          <br />
          <span itemProp="postalCode">{zipcode}</span>{' '}
          <span itemProp="addressLocality">{city}</span>
        </ContentSection>
        <ContentSection>
          {tel && (
            <span>
              {t('blocks.shops.map.phone')}
              <a itemProp="telephone" href={`tel:${tel}`}>
                {tel}
              </a>
            </span>
          )}
          {tel && fax && <br />}
          {fax && (
            <span>
              {t('blocks.shops.map.fax')}
              <a itemProp="faxNumber" href={`fax:${fax}`}>
                {fax}
              </a>
            </span>
          )}
        </ContentSection>
        <ContentSection itemProp="openingHours">
          {shop.opening_hours &&
            shop.opening_hours
              .split('\n')
              .map((line, index, { length }) => [
                line,
                index < length - 1 && <br key={`br${index}`} />
              ])}
        </ContentSection>
        <CTASection>
          <Button
            variant="primary"
            onClick={handleActionClick}
            loading={actionPending}
          >
            <Button.children.Text>
              {t('blocks.shops.map.calculateRoute')}
            </Button.children.Text>
          </Button>
        </CTASection>
      </Fragment>
    );
  }
}
